export const prefix = '/_api/crm-inbox-server/chat';
export const widgetRenderPrefix = '/chat-widget-server/renderChatWidget';
export const prefixAvailability = '/_api/availability-hours-server/v1/chat';
export const prefixLcf = '/_api/auto-messages-server/v1/lcf';
export const prefixSocial = '/_api/chat-integration/v1/social';
export const prefixGroup = '/_api/chat-integration/v1/social/group-chatrooms';
export const prefixChatPayments = '/_api/chat-payments/api';

export const INIT_URL = window.__CHAT_INIT_URL__ || `${prefix}/init`;
export const EDITOR_SETTINGS_URL = `${prefix}/settings/editor`;
export const UPLOAD_TOKEN_URL = `${prefix}/uploadToken`;
export const IMAGE_PREVIEW_PAGE = `${widgetRenderPrefix}/imagePreview`;

export const LCF_POST_FORM_URL = `${prefixLcf}/submissions`;

export const MEMBER_LIST_URL = `${prefixSocial}/candidates`;
export const CREATE_CHAT_ROOM_URL = `${prefixSocial}/private-chatrooms`;
export const CREATE_CHAT_GROUP_ROOM_URL = `${prefixGroup}`;
export const LEAVE_CHAT_GROUP_ROOM_URL = `${prefixGroup}/participants/leave`;
export const UPDATE_SOCIAL_GROUP_PARTICIPANTS_URL = `${prefixGroup}/participants`;
export const UPDATE_CHAT_GROUP_ROOM_URL = `${prefixGroup}`;

export const CHAT_STATUS_URL = `${prefixAvailability}/status`;

export const REPORT_FIRST_EXPAND_URL = `${prefix}/firstExpand`;

export const PAYMENT_SUMMARY = `${prefixChatPayments}/get-payment-summary`;
